import { render } from "./PixKeyCard.vue?vue&type=template&id=823cd908&scoped=true"
import script from "./PixKeyCard.vue?vue&type=script&lang=js"
export * from "./PixKeyCard.vue?vue&type=script&lang=js"

import "./PixKeyCard.vue?vue&type=style&index=0&id=823cd908&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-823cd908"]])

export default __exports__